const common={}
export const CommonData = (state=common, action) => { 
    switch (action.type) {
         case 'getCommonData':
              return state = action.payload
              
         default:
              return state
    }
}